<template>
    <span><slot v-if="this.active"/> {{ remaining.seconds }}</span>
</template>

<script>
export default {
    name: "Countdown",
    props: {
        left: Object,
        active: Boolean,
        updateAllowed: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            timer: null,
            remaining: this.left
        }
    },
    mounted() {
        this.checkCountdown();
    },
    destroyed() {
        this.clearInterval();
    },
    updated() {
        this.checkCountdown();
    },
    methods: {
        checkCountdown() {
            let self = this;
            if (this.active && this.timer === null) {
                this.timer = setInterval(() => {
                    if (self.remaining.seconds > 0) {
                        self.remaining.seconds--;
                        this.$emit('timerUpdate', self.remaining.seconds);
                    }
                }, 1000);
            }
        },
        clearInterval() {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    watch: {
        left(remaining) {
            if (this.updateAllowed) {
                this.clearInterval();
                this.remaining = remaining;
            }
        }
    }
}
</script>
